import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME, isSupabaseConfigured } from '@/config';
import { getTransferFeed } from '@/lib/data/provider';

/** The mercato board: recent real-world player moves (photo, clubs, fee, date). */
export function useTransferFeed(limit = 40) {
  return useQuery({
    queryKey: ['transfers', 'feed', limit],
    queryFn: () => getTransferFeed(limit),
    staleTime: QUERY_STALE_TIME.reference,
    enabled: isSupabaseConfigured,
  });
}
